import { updateObject } from "utils/helpers/updateObject";
import {
  actionTypes,
  CreateMembershipPlanFailAction,
  CreateMembershipPlanRequestAction,
  CreateMembershipPlanSuccessAction,
  FetchMembershipPlanFailAction,
  FetchMembershipPlanRequestAction,
  FetchMembershipPlanSuccessAction,
  FetchMembershipPlanSummaryFailAction,
  FetchMembershipPlanSummaryRequestAction,
  FetchMembershipPlanSummarySuccessAction,
  MembershipPlanActions,
  stateStatusType,
  UpdateMembershipPlanFailAction,
  UpdateMembershipPlanRequestAction,
  UpdateMembershipPlanSuccessAction,
} from "./actionType";
import { initialState, MembershipPlanState, } from "./state";

const fetchMembershipPlanRequest = (
  state: MembershipPlanState,
  action: FetchMembershipPlanRequestAction
) => {
  return updateObject(state, {
    fetchmembershiPlanState: {
      ...state.fetchmembershiPlanState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const fetchMembershipPlanSuccess = (
  state: MembershipPlanState,
  action: FetchMembershipPlanSuccessAction
) => {
  return updateObject(state, {
    fetchmembershiPlanState: {
      ...state.fetchmembershiPlanState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      membershipPlan: action.payload,
    },
  });
};

const fetchMembershipPlanFail = (
  state: MembershipPlanState,
  action: FetchMembershipPlanFailAction
) => {
  return updateObject(state, {
    fetchmembershiPlanState: {
      ...state.fetchmembershiPlanState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      membershipPlan: null,
    },
  });
};
const fetchMembershipPlanSummaryRequest = (
  state: MembershipPlanState,
  action: FetchMembershipPlanSummaryRequestAction
) => {
  return updateObject(state, {
    fetchmembershiPlanState: {
      ...state.fetchmembershiPlanState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const fetchMembershipPlanSummarySuccess = (
  state: MembershipPlanState,
  action: FetchMembershipPlanSummarySuccessAction
) => {
  return updateObject(state, {
    fetchmembershiPlanState: {
      ...state.fetchmembershiPlanState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      membershipPlan: action.payload,
    },
  });
};

const fetchMembershipPlanSummaryFail = (
  state: MembershipPlanState,
  action: FetchMembershipPlanSummaryFailAction
) => {
  return updateObject(state, {
    fetchmembershiPlanState: {
      ...state.fetchmembershiPlanState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      membershipPlan: null,
    },
  });
};

//create
const createMembershipPlanRequest = (
  state: MembershipPlanState,
  action: CreateMembershipPlanRequestAction
) => {
  return updateObject(state, {
    fetchmembershiPlanState: {
      ...state.fetchmembershiPlanState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const createMembershipPlanSuccess = (
  state: MembershipPlanState,
  action: CreateMembershipPlanSuccessAction
) => {
  const expistingData = state.fetchmembershiPlanState.membershipPlan ?? []
  return updateObject(state, {
    genericMembershipPlanState: {
      ...state.genericMembershipPlanState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      updatedData:action.payload
    },
    fetchmembershiPlanState: {
      ...state.fetchmembershiPlanState,
      membershipPlan: [...expistingData, action.payload],
    },
  });
};

const createMembershipPlanFail = (
  state: MembershipPlanState,
  action: CreateMembershipPlanFailAction
) => {
  return updateObject(state, {
    genericMembershipPlanState: {
      ...state.genericMembershipPlanState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    fetchmembershiPlanState: {
      ...state.fetchmembershiPlanState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
  });
};

//update
const updateMembershipPlanRequest = (
  state: MembershipPlanState,
  action: UpdateMembershipPlanRequestAction
) => {
  return updateObject(state, {
    fetchmembershiPlanState: {
      ...state.fetchmembershiPlanState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const updateMembershipPlanSuccess = (
  state: MembershipPlanState,
  action: UpdateMembershipPlanSuccessAction
) => {
  const newData =
    state.fetchmembershiPlanState.membershipPlan?.map((item)=> item.id === action.payload.id ? action.payload : item) ?? [];
  return updateObject(state, {
    genericMembershipPlanState: {
      ...state.genericMembershipPlanState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      updatedData:action.payload
    },
    fetchmembershiPlanState: {
      ...state.fetchmembershiPlanState,
      membershipPlan: [...newData],
    },
  });
};

const updateMembershipPlanFail = (
  state: MembershipPlanState,
  action: UpdateMembershipPlanFailAction
) => {
  return updateObject(state, {
    genericMembershipPlanState: {
      ...state.genericMembershipPlanState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    fetchmembershiPlanState: {
      ...state.fetchmembershiPlanState,
      isLoading: false,
      status: stateStatusType.FAILED,
    },
  });
};

const fetchMembershipPlanReducer = (
  state = initialState,
  action: MembershipPlanActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_MEMBERSHIP_PLANS_REQUEST:
      return fetchMembershipPlanRequest(state, action);
    case actionTypes.FETCH_MEMBERSHIP_PLANS_SUCCESS:
      return fetchMembershipPlanSuccess(state, action);
    case actionTypes.FETCH_MEMBERSHIP_PLANS_FAIL:
      return fetchMembershipPlanFail(state, action);
    case actionTypes.CREATE_MEMBERSHIP_PLAN_REQUEST:
      return createMembershipPlanRequest(state, action);
    case actionTypes.CREATE_MEMBERSHIP_PLAN_SUCCESS:
      return createMembershipPlanSuccess(state, action);
    case actionTypes.CREATE_MEMBERSHIP_PLAN_FAIL:
      return createMembershipPlanFail(state, action);
    case actionTypes.UPDATE_MEMBERSHIP_PLAN_REQUEST:
      return updateMembershipPlanRequest(state, action);
    case actionTypes.UPDATE_MEMBERSHIP_PLAN_SUCCESS:
      return updateMembershipPlanSuccess(state, action);
    case actionTypes.UPDATE_MEMBERSHIP_PLAN_FAIL:
      return updateMembershipPlanFail(state, action);
    default:
      return state;
  }
};

export default fetchMembershipPlanReducer;
